import { render, staticRenderFns } from "./LogoutUser.vue?vue&type=template&id=427c29f7&"
import script from "./LogoutUser.vue?vue&type=script&lang=js&"
export * from "./LogoutUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports